module.exports = __webpack_public_path__ + "static/media/placeholder-user.08f0607c.png";